import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Diamond from '../../assets/images/diamond.svg';
import FeaturedTitle from '../../assets/images/tournament-title.png';
import Ludo from '../../images/Ludo1.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { featureTournamentList, tournamentByCode } from "../../api/tournament.api";
import { url } from "../../config/url";
import { toastError } from '../../Utilities/toast';

import TournamentViaCode from "../Common/JoinViaTournamentCode";

export const initialFilter = {
  pagination: {
    pageNo: 1,
    recordPerPage: 10,
    sortBy: "startDate",
    sortDirection: "asc"
  }
};

const FeaturedTournament = ({setLoading}) => {
  const { t } = useTranslation()
  const [filter, setFilter] = useState(initialFilter);
  const [list, setList] = useState([]);
  const [error, setError] = useState("");
  const [helperText, setHelperText] = useState("");
  const [isTournament, setIsTournament] = useState(false);
  const [joinViaCodeTournament, setJoinViaCodeTournament] = useState({});

  useEffect(() => {
    setLoading(true)
    fetchTournaments();
  }, [])

  const fetchTournaments = async () => {
    try {
      let data = filter;
      const res = await featureTournamentList(data);
      if (res?.success && res?.data?.length > 0) {
        setList(res?.data)
      }
      else {
        setList([]);
      }
    } catch (error) {
    }
    setLoading(false)
  };

  const handleSubmit = (inviteCode) => {
    setJoinViaCodeTournament({});
    setIsTournament(false)

    // Validation logic
    if (inviteCode === "") {
      setError(true);
      setHelperText("Please enter invite code");
    } else if (inviteCode.length < 6) {
      setError(true);
      setHelperText("Please enter a 6 character invite code");
    } else {
      // No error, proceed with the submission
      handleTournamentByCode(inviteCode)
      setError(false);
      setHelperText("");
      // Handle the invite code submission logic here
    }
  };

  async function handleTournamentByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await tournamentByCode(payload);
        if (response?.success && response?.data) {
          setJoinViaCodeTournament(response?.data);
          setIsTournament(true)
        } else {
          toastError(response?.data?.errors?.[0]?.msg);
        }
      } catch (error) {
        toastError(error?.response?.data?.errors?.[0]?.msg);
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
      setIsTournament(false)
    }
  }

  return (
    <>
      {list?.length > 0 ?
   <section className='featured-box'>
   <div className='home-header'>
     <img className='icon-24 me-2' src={FeaturedTitle} alt="featuredTitle" />
     <span className='home-header-v2'>{t('featuredTournament')}</span>
   </div>
   <Swiper
     spaceBetween={10}
     slidesPerView={3} 
     breakpoints={{
      0: {
        slidesPerView: 3, 
      },
      370: {
        slidesPerView: 3, 
      },
      768: {
        slidesPerView: 3, 
      },
     }}
   >
     {list?.map((item, index) => (
       <SwiperSlide key={index}>
         <div className='feature-box' onClick={() => {
           localStorage.setItem("activeGame", item?.gameAry?.name);
           localStorage.setItem("activeGameId", item?.gameAry?._id);
           handleSubmit(item?.shortCode);
         }}>
           <div className='first'>
             <div className="overlay"></div>
             <img src={url?.IMAGE_URL + item?.featuredImage?.default} alt="img" className='feature-tournament-img' />
             <div className='game-name-title'>
               <p>
                 {item?.title?.length > 12 ? (
                   <marquee>{item?.title}</marquee>
                 ) : (
                   item?.title
                 )}
               </p>
               <p>
                 {item?.gameAry?.name?.length > 12 ? (
                   <marquee>{item?.gameAry?.name}</marquee>
                 ) : (
                   item?.gameAry?.name
                 )}
               </p>
             </div>
           </div>
           <div className='second d-flex justify-content-center align-items-end'>
             {item?.prizePoolType === 'amount' ? (
               <span>
                 {item?.prizePool}
                 <img className='icon-16 mx-1' src={url?.IMAGE_URL + item?.currency?.[0]?.outCurrency?.img?.default} alt="diamond" />
               </span>
             ) : (
               <span>{item?.rewardDisplayText}</span>
             )}
           </div>
         </div>
       </SwiperSlide>
     ))}
     <div className="swiper-pagination"></div>
   </Swiper>
 </section>
 
    
        :
        <></>}
      {isTournament && <TournamentViaCode joinViaCodeTournament={joinViaCodeTournament} />}
    </>
  )
}

export default FeaturedTournament